import React, {ReactNode} from 'react';
import NavTabLink from './NavTabLink';
import {ActiveTabState, NavTabsState} from './types.ts';
import {ReactStateSetter} from '../../../types.ts';
import classNames from 'classnames';

interface NavTabsLinksProps {
    navTabsState: NavTabsState;
    setActiveTabState: ReactStateSetter<ActiveTabState>;
    // Buttons that live on the tab bar but aren't tabs: "Add tab", "Full
    // screen". They sit at the right, after the tabs.
    trailing?: ReactNode;
    label?: string;
    className?: string;
}

const NavTabsLinks: React.FC<NavTabsLinksProps> = ({
    navTabsState,
    setActiveTabState,
    trailing,
    label,
    className
}) => {
    return (
        <ul
            className={classNames('nav nav-tabs mx-tabs', className)}
            role="tablist"
            aria-label={label}
        >
            {navTabsState.tabs
                .filter(tab => tab.available)
                .map(tab => (
                    <NavTabLink
                        navTabsState={navTabsState}
                        setActiveTabState={setActiveTabState}
                        tab={tab}
                        key={tab.name}
                    />
                ))}
            {trailing && (
                <li className="nav-item mx-tabs-trailing" role="presentation">
                    {trailing}
                </li>
            )}
        </ul>
    );
};

export default NavTabsLinks;
